import React from "react";
import {Unit, Wing, UnitDark, WingDark, RoomDark, Room} from "../../constants/ProIcons"
import _ from 'lodash'

export const selectedLevelType = (option, props) => {   
    if (option) {
        return (
            <div className="country-item country-item-value">
                {_.isEqual(option.icon,"Wing")?<Wing/> 
                :_.isEqual(option.icon, "Unit")? <Unit/> 
                :_.isEqual(option.icon, "Room")? <Room/> 
                :_.isEqual(option.key, "BED")?<i className={option.icon} style={{ color: "rgb(87, 152, 0)" }}></i> 
                :<i className={option.icon} style={{color: '#384C7E'}}></i> }
                <div style={{ display: "inline-block", marginLeft: "10px" }}>
                    {option.name}
                </div>
            </div>
        );
    }
    return <span>{props.placeholder}</span>;
};

export const levelOptionType = (option) => {
    return (
        <div className="country-item">
            {_.isEqual(option.icon,"Wing")?<WingDark/> 
            :_.isEqual(option.icon, "Unit")? <UnitDark/> 
            :_.isEqual(option.icon, "Room")? <RoomDark/> 
            :_.isEqual(option.key, "BED")? <i className={option.icon} style={{color: "rgb(87, 152, 0)"}}></i>
            : <i className={option.icon} style={{color:"#666666"}} ></i>}
            <div style={{ display: "inline-block", marginLeft: "10px"}}>
                {option.name}
            </div>
        </div>
    );
};